import type { TemplateFn } from "./index";
import { baseTimeline, pathTargets } from "./_helpers";

// Two-phase classic. Phase 1 (0-70%): paths draw on as outlined strokes.
// Phase 2 (70-100%): fill fades in, stroke fades out. The slight overlap at
// 65-75% (where strokes are 100% drawn but fill is just appearing) is what
// makes the transition feel intentional rather than "stop drawing, now paint".
export const strokeReveal: TemplateFn = (ir, logo) => {
  const base = baseTimeline(ir, logo);
  const targets = pathTargets(logo);
  const n = Math.max(1, targets.length);
  // Stagger is in *normalized* time. Smaller for many paths so the draw-on
  // doesn't take forever; larger for few paths so each line gets its moment.
  const stagger = Math.min(0.18, 0.35 / n);
  const drawSpan = 0.55;          // each path takes ~55% of normalized time to draw
  const fillStart = 0.68;

  const tracks = targets.map((sel, i) => {
    const start = i * stagger;
    const drawn = Math.min(start + drawSpan, 0.92);
    return {
      target: sel,
      easing: "easeInOutCubic" as const,
      delay: 0,
      keyframes: [
        { t: 0,           opacity: 1, fillOpacity: 0, strokeOpacity: 1, strokeDashoffset: 1, strokeDasharray: 1 },
        { t: start,       strokeDashoffset: 1, fillOpacity: 0 },
        { t: drawn,       strokeDashoffset: 0, fillOpacity: 0 },
        { t: fillStart,   strokeDashoffset: 0, fillOpacity: 0.0, strokeOpacity: 1 },
        { t: 1,           strokeDashoffset: 0, fillOpacity: 1, strokeOpacity: 0 },
      ],
    };
  });
  return { ...base, tracks };
};
